import React, { useEffect } from "react";
import {
  Button,
  Form,
  TextInput,
  Row,
  Column,
  Select,
  SelectItem,
  PasswordInput,
  ButtonSet,
} from "carbon-components-react";
import ArrowRight24 from "@carbon/icons-react/es/arrow--right/24";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import {
  userSchema,
  roleRules,
  passwordRules,
} from "../../services/SchemaService";
import useGet from "../../hooks/useGet";
import http from "../../http-common";
import * as yup from "yup";
import { useState } from "react";
import { RuleCancelled24, SaveModel24 } from "@carbon/icons-react";
import { Checkbox } from "carbon-components-react";

const UserForm = ({
  mode,
  url,
  successMessage,
  onSuccessNavigateTo,
  username,
}) => {
  const { data: roles } = useGet("/lookup/user-roles");
  const [opMode] = useState(mode);
  const [showProfiles] = useState(mode !== "SIGNUP");
  const [showPassword] = useState(mode !== "UPDATE");
  const [user, setUser] = useState({});
  // const [role, setRole] = useState(user.role);
  const [showSuccess, setShowSuccess] = useState(false);
  const [data, setData] = useState(null);
  const [resetTempPassword, setResetTempPassword] = useState(null);
  const [isJury, setIsJury] = useState(false);
  //const { data: foundUser } = useGet(`/users/${username}`);

  const getSchema = () => {
    switch (mode) {
      case "CREATE":
        return userSchema.concat(roleRules).concat(passwordRules);
      case "UPDATE":
        return userSchema.concat(roleRules);
      case "SIGNUP":
        return userSchema.concat(passwordRules);
      default:
        return userSchema;
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(getSchema()), mode: "onBlur" });

  const navigate = useNavigate();

  const handleChangeRole = async (e) => {
    setIsJury(e.target.value == 204);
  };

  const onSubmit = async (data) => {
    try {
      if (!isJury) {
        data.tiebreaker = false;
      }
      opMode === "UPDATE"
        ? await http.put(url, data)
        : await http.post(url, data);
      toast.success(successMessage);

      if (opMode === "SIGNUP") {
        reset({});
        setData(data);
        setShowSuccess(true);
      } else {
        navigate(onSuccessNavigateTo, { replace: true });
      }
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  const resetPassword = async () => {
    try {
      const response = await http.put(`/users/reset/${username}`);
      setResetTempPassword(response.data.tempPassword);
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  useEffect(() => {
    if (opMode === "UPDATE") {
      const fetchData = async () => {
        try {
          const result = await http.get(`/users/${username}`);
          const fields = [
            "id",
            "username",
            "firstName",
            "lastName",
            "email",
            "roleCode",
            "tiebreaker",
          ];
          setIsJury(result.data.roleCode == 204);
          fields.forEach((field) => setValue(field, user[field]));
          setUser(result.data);
        } catch (error) {
          toast.error(error.response?.data.message);
        }
      };

      fetchData();
    }
    setShowSuccess(false);
  }, [opMode]);

  useEffect(() => {
    reset(user);
  }, [user]);

  return (
    <>
      {showSuccess ? (
        <div className="emprega-green">
          <h5>Obrigado por se registar</h5>
          <p>
            O teu login é {data.username} e a senha é {data.password}. Guarde
            bem para poderes voltar a aceder à tua conta.
          </p>
          {/* <p>
            A sua conta foi criada com sucesso e será activada brevemente. Após
            a activação, receberá uma notificação/mensagem.
          </p> */}
        </div>
      ) : (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Column sm={6} md={6} lg={6} className="required">
              <TextInput
                id="firstName"
                labelText="Nome"
                maxLength={64}
                {...register("firstName")}
              />
              <p className="field-error">{errors.firstName?.message}</p>
            </Column>
            <Column sm={6} md={6} lg={6} className="required">
              <TextInput
                id="lastName"
                labelText="Apelido"
                maxLength={64}
                {...register("lastName")}
              />
              <p className="field-error">{errors.lastName?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column sm={12} md={6} lg={6} className="required">
              <TextInput
                id="username"
                labelText="Número de telefone"
                {...register("username")}
                maxLength={9}
              />
              <p className="field-error">{errors.username?.message}</p>
            </Column>
            <Column sm={12} md={6} lg={6}>
              <TextInput id="email" labelText="Email" {...register("email")} />
              <p className="field-error">{errors.email?.message}</p>
            </Column>
          </Row>
          {showProfiles && (
            <Row>
              <Column sm={2} md={6} lg={6} className="required">
                <Select
                  id="roleCode"
                  labelText="Perfil"
                  {...register("roleCode")}
                  onChange={handleChangeRole}
                >
                  <SelectItem text="" value="" />
                  {roles.map((p) => (
                    <SelectItem
                      text={p.description}
                      value={p.code}
                      key={p.code}
                    />
                  ))}
                </Select>

                <p className="field-error">{errors.roleCode?.message}</p>
              </Column>
              <Column sm={2} md={6} lg={6}>
                {isJury && (
                  <Checkbox
                    labelText="Júri de desempate"
                    id="tiebreaker"
                    name="tiebreaker"
                    className="mt-2"
                    disabled={!isJury}
                    {...register("tiebreaker")}
                  />
                )}
              </Column>
            </Row>
          )}
          {showPassword && (
            <Row>
              <Column sm={12} md={6} lg={6} className="required">
                <PasswordInput
                  id="password"
                  labelText="Senha"
                  maxLength={16}
                  {...register("password")}
                />
                <p className="field-error">{errors.password?.message}</p>
              </Column>
              <Column sm={12} md={6} lg={6} className="required">
                <PasswordInput
                  id="passwordConfirm"
                  labelText="Confirmação da Senha"
                  maxLength={16}
                  {...register("passwordConfirm")}
                />
                <p className="field-error">{errors.passwordConfirm?.message}</p>
              </Column>
            </Row>
          )}
          <Row className="mt-2">
            <Column sm={12} md={12} lg={12} className="form-buttons">
              <ButtonSet>
                <Button
                  type="submit"
                  renderIcon={SaveModel24}
                  iconDescription="Save"
                >
                  Submeter
                </Button>
              </ButtonSet>
              {mode === "UPDATE" && (
                <ButtonSet>
                  <Button
                    type="button"
                    onClick={resetPassword}
                    className="emprega-bg-orange"
                  >
                    Password Reset
                  </Button>
                </ButtonSet>
              )}
            </Column>
            {/* {mode === "SIGNUP" ? (
              <Column sm={12} md={6} lg={6}>
                <p style={{ color: "#000", paddingTop: "10px" }}>
                  Já te registaste? Faz <Link to={"/"}>login</Link>
                </p>
              </Column>
            ) : (
              ""
            )} */}
          </Row>
          {mode === "UPDATE" && resetTempPassword && (
            <Row className="mt-2">
              <Column sm={12} md={12} lg={12}>
                <div className="emprega-green">
                  <p>Senha temporária gerada: <strong>{resetTempPassword}</strong></p>
                  <p>Por favor, informe o utilizador através de outro canal (telefone, WhatsApp, etc.).</p>
                </div>
              </Column>
            </Row>
          )}
        </Form>
      )}
    </>
  );
};

export default UserForm;
